import { defineStore } from 'pinia'
import type { components, paths } from '@/types/gateway_schema'
import createClient from 'openapi-fetch'
import { useCookies } from '@/components/composable/composable_cookie'
import { toast } from 'vue-sonner'

type DataStoreState = {
  electricity: components['schemas']['LGCEnergyDTO']
  solar: components['schemas']['LGCSolarDTO']
  water: components['schemas']['LGCWaterDTO']
  waste: components['schemas']['LGCWasteDTO']
  currentViewIndex: number
}

const client = createClient<paths>({
  baseUrl: '/gateway/',
})
export const useDataStore = defineStore('data', {
  state: (): DataStoreState => ({
    electricity: {
      energy_saved: 0,
      variation: 0,
      chart_trend_offices: 0,
      chart_trend_restaurants: 0,
      chart_trend_hvac: 0,
      chart_trend_others: 0,
      chart_year_current: [],
      chart_year_before: [],
    },
    solar: {
      energy_produced: 0,
      energy_year_current: [],
      energy_year_last: [],
    },
    water: {
      city_water_saved: 0,
      month_consuption: 0,
      year_consuption_current: [],
      year_consuption_before: [],
      restaurant_consuption: 0,
      gym_consuption: 0,
      offices_consuption: 0,
    },
    waste: {
      waste_sorting_rate_monthly: 0,
      waste_sorting_rate_yearly_current: [],
      waste_sorting_rate_yearly_before: [],
      waste_sorting_rate_moving_average: [],
      waste_tonnage_by_type: {
        MAT_ORGA: 0,
        DECH_NDG: 0,
        VERRE: 0,
        DECH_REC: 0,
        PC: 0,
      },
    },
    currentViewIndex: 0,
  }),
  getters: {
    getElectricity: (state) => state.electricity,
    getSolar: (state) => state.solar,
    getWater: (state) => state.water,
    getWaste: (state) => state.waste,
    getCurrentViewIndex: (state) => state.currentViewIndex,
    getJWT: (_) => {
      const { getCookieValue } = useCookies()
      const cookie = getCookieValue('hv_jwt')
      return cookie
    },
  },
  actions: {
    async fetchLGCData() {
      return client
        .GET('/api/dashboard/lgc', {
          headers: { 'X-AUTH-TOKEN': this.getJWT.value },
        })
        .then((response) => {
          if (response.data) {
            this.electricity = response.data.electricity
            this.solar = response.data.solar
            this.water = response.data.water
            this.waste = response.data.waste
          }
        })
        .catch((e) => {
          toast.error(`Erreur lors de la récupération des données.`)
        })
    },
    setCurrentViewIndex(index: number) {
      this.currentViewIndex = index
    },
  },
})
